import { render, staticRenderFns } from "./CollectionImageCarouselIndex.vue?vue&type=template&id=43efc36c&scoped=true&"
import script from "./CollectionImageCarouselIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionImageCarouselIndex.vue?vue&type=script&lang=js&"
import style0 from "./CollectionImageCarouselIndex.vue?vue&type=style&index=0&id=43efc36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efc36c",
  null
  
)

export default component.exports